import { __assign } from "tslib";
import { ExtendedTypography } from '@cseo/styles';
import { getResponsivePanelWidth, getResponsivePanelMargin, CoherencePanelSize } from '@cseo/coherence-utilities';
export var getStyles = function (props) {
    var theme = props.theme, isFooterInBody = props.isFooterInBody, _a = props.panelSize, panelSize = _a === void 0 ? CoherencePanelSize.small : _a, _b = props.panelBodyResponsiveMargin, panelBodyResponsiveMargin = _b === void 0 ? true : _b;
    return {
        subComponentStyles: {
            panelStyles: {
                main: {
                    selectors: __assign({}, getResponsivePanelWidth(panelSize, isFooterInBody))
                },
                root: [
                    {
                        marginTop: '48px'
                    },
                    isFooterInBody && {
                        marginTop: '0px'
                    }
                ],
                navigation: {
                    height: '40px'
                },
                closeButton: {
                    color: theme.palette.neutralPrimary
                },
                overlay: {
                    backgroundColor: theme.palette.blackTranslucent40
                }
            }
        },
        backButtonContainer: {
            flex: '1 1 auto'
        },
        backButton: {
            padding: '0px',
            height: '40px',
            color: theme.palette.neutralPrimary
        },
        header: [
            ExtendedTypography.size26Bold,
            {
                color: theme.palette.neutralPrimary,
                marginTop: '8px',
                marginBottom: '32px',
                selectors: __assign({}, getResponsivePanelMargin(panelSize, undefined))
            },
            isFooterInBody && {
                marginTop: '0px',
                marginBottom: '8px'
            }
        ],
        body: {
            selectors: panelBodyResponsiveMargin ? __assign({}, getResponsivePanelMargin(panelSize, undefined)) : { margin: '0px' }
        },
        footer: {
            color: theme.palette.neutralPrimary,
            marginTop: '24px',
            marginBottom: '24px',
            display: 'flex',
            selectors: __assign({ '.ms-Button': {
                    marginRight: '12px'
                } }, getResponsivePanelMargin(panelSize, isFooterInBody))
        }
    };
};
//# sourceMappingURL=CoherencePanel.styles.js.map